<div class="one-dialog">
    <div class="dialog-header d-flex">
        <div class="title flex-grow-1">
            <h2 mat-dialog-title>{{title}}</h2>
        </div>
        <div class="right">
            <button mat-icon-button mat-dialog-close aria-label="Close dialog icon">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
    <mat-dialog-content>
        <div class="dialog-body">
            <div class="row">
                <div class="col-md-3">
                    <div class="label form-label">{{text.GROUP_NAME}} *</div>
                </div>
                <div class="col-md-9">
                    <mat-form-field class="full" appearance="outline" color="warn">
                        <mat-label>{{text.GROUP_NAME}}</mat-label>
                        <input matInput placeholder="{{text.GROUP_NAME}}" [formControl]="requestGroupFormGroup.controls.name" [(ngModel)]="newGroupRequest.name">
                        <mat-error *ngIf="requestGroupFormGroup.controls.name.invalid">{{getNameErrorMessage()}}</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <div class="label form-label">{{text.APPROVER}} *</div>
                </div>
                <div class="col-md-9">
                    <one-user-select [label]="text.APPROVER"
                                    [allUsers]="users"
                                    [oneControl]="requestGroupFormGroup.controls.approvers"></one-user-select>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <div class="label">{{text.DIRECT_MANAGER_APPROVAL}}</div>
                </div>
                <div class="col-md-9">
                    <mat-slide-toggle class="full" labelPosition="before" color="warn" [(ngModel)]="requiredDM">
                    </mat-slide-toggle>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <div class="label form-label">{{text.WORKFLOW_LABEL}}</div>
                </div>
                <div class="col-md-9">
                    <mat-form-field class="full" appearance="outline" color="warn">
                        <mat-label>{{text.WORKFLOW_LABEL}}</mat-label>
                        <mat-select [(value)]="newGroupRequest.approveType">
                            <mat-option *ngFor="let type of approvalTypes" [value]="type.id">
                                {{type.friendlyName}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <div class="label">{{text.CUSTOM_FORM}}</div>
                </div>
                <div class="col-md-9">
                    <mat-slide-toggle class="full" labelPosition="before" color="warn" [(ngModel)]="customForm">
                    </mat-slide-toggle>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <div class="label form-label">{{text.GROUP_CATEGORY_LABEL}}</div>
                </div>
                <div class="col-md-9">
                    <mat-form-field class="full" appearance="outline" color="warn">
                        <mat-label>{{text.GROUP_CATEGORY_LABEL}}</mat-label>
                        <input matInput placeholder="{{text.GROUP_CATEGORY_LABEL}}" [(ngModel)]="newGroupRequest.category">
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <div class="label form-label">{{text.SLA}}</div>
                </div>
                <div class="col-md-9">
                    <mat-form-field class="full" appearance="outline" color="warn">
                        <mat-label>{{text.SLA}}</mat-label>
                        <input matInput type="number" placeholder="Vd: 8" [formControl]="requestGroupFormGroup.controls.SLA" min="0" [(ngModel)]="groupSla">
                        <span matSuffix>{{text.SLA_UNIT}}</span>
                        <mat-error *ngIf="requestGroupFormGroup.controls.SLA.invalid">{{getSLAErrorMessage()}}</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row" *ngIf="departments.length > 0">
                <div class="col-md-3">
                    <div class="label form-label">{{text.DEPARTMENT}}</div>
                </div>
                <div class="col-md-9">
                    <mat-form-field class="full" appearance="outline" color="warn">
                        <mat-label>{{text.DEPARTMENT}}</mat-label>
                        <mat-select [(value)]="newGroupRequest.targetId">
                            <mat-option [value]="0">Toàn công ty</mat-option>
                            <mat-option *ngFor="let dep of departments" [value]="dep.id" >{{dep.name}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <div class="label form-label">{{text.FOLLOWER}}</div>
                </div>
                <div class="col-md-9">
                    <one-user-select [label]="text.FOLLOWER"
                                    [allUsers]="users"
                                    [oneControl]="requestGroupFormGroup.controls.followers"></one-user-select>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <div class="label form-label">{{text.DESCRIPTION}}</div>
                </div>
                <div class="col-md-9">
                    <mat-form-field class="full" appearance="outline" color="warn">
                        <mat-label>{{text.DESCRIPTION}}</mat-label>
                        <textarea matInput rows="5" [(ngModel)]="newGroupRequest.description"></textarea>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close>{{text.CANCEL}}</button>
        <button mat-raised-button color="warn" (click)="onSave()" [disabled]="isInvalidData || submited" >{{saveText}}</button>
    </mat-dialog-actions>
</div>
